import axios from 'axios';
import { ASSETS_ROOT } from '../../config/api';

const themeActions = {
  GET: 'THEME_GET',
  GET_FAILED: 'THEME_GET_FAILED',
  GET_LEGACY: 'THEME_GET_LEGACY',
  GET_LEGACY_FAILED: 'THEME_GET_LEGACY_FAILED',
  GET_LEGACY_SUCCESS: 'TTHEME_GET_LEGACY_SUCCESS',
  GET_SUCCESS: 'THEME_GET_SUCCESS',

  getFailed: (data) => ({
    payload: {
      data,
    },
    type: themeActions.GET_FAILED,
  }),
  getLegacy: (data) => ({
    payload: data,
    type: themeActions.GET_LEGACY,
  }),
  getLegacySuccess: (data) => ({
    payload: data,
    type: themeActions.GET_LEGACY_SUCCESS,
  }),
  getSuccess: (data) => ({
    payload: {
      data,
    },
    type: themeActions.GET_SUCCESS,
  }),
  getTheme: () => ({
    payload: {
      request: () => axios.get(`${ASSETS_ROOT}/theme.json`),
    },
    type: themeActions.GET,
  }),
};

export default themeActions;
